module.exports = __webpack_public_path__ + "static/media/Twemoji12 1f6d1.2ff27b39.svg";